/* globals $, data, vizData, leagueData, serverParams */
/* eslint-disable import/no-relative-packages */
/* eslint-disable no-param-reassign */
/* eslint-disable no-new */
import * as d3 from 'd3'
import setTextColorWithBackground from 'bam-node-baseball-savant/utils/set-text-color-with-background.ts'

import Table from 'bam-node-savant-table/table'
import { populateUrl } from 'bam-node-baseball-savant/leaderboard/utils/leaderboard-filter-helpers'
import { slideUp, slideDown } from '../utils/leaderboard-drawer-helpers'
import * as viz from '../catcher-framing-zone-viz'
// eslint-disable-next-line
import * as graphViz from '../catcher-framing-graph-viz'

import initStaticHeaders from '../utils/static-headers'
import concatGroupedHeaders from '../utils/concat-grouped-headers'

import {
    groupHeaders,
    headers,
    headersDefault,
    secondaryHeaders,
    secondaryHeadersDefault,
    allPitchHeaders,
    vizTableHeaders,
    getGroupedTableHeaders,
    getSecondaryVizTableHeaders,
} from '../catcher-framing/headers'

const attackZone = require('bam-node-bdata-charts/chart.attack-zone')
const {
    // ZONE_INCHES_UPPER_LIMIT,
    ZONE_INCHES_LIMIT,
} = require('bam-node-baseball-savant/constants/catcher-framing-viz-constants')

const tableDivId = 'catcher_framing_table'
let showLeagueAverage = false

const shadowZones = [11, 12, 13, 14, 16, 17, 18, 19]
const shadowTop = [11, 12, 13]
const shadowBottom = [17, 18, 19]
const groupZones = [
    'shadowtop',
    'shadowbottom',
    'shadowleft',
    'shadowright',
    'heart',
    'chasewaste',
]
const framingPitchesMap = {}
const groupedPitchesMap = {}

let leftSelect
let rightSelect

if (serverParams.type === 'catcher') {
    leftSelect = d3.select('#viz_left_select')
    rightSelect = d3.select('#viz_right_select')
}

let groupedView = false
let isBreakdown = false

function getNewZoneArray() {
    const zoneArray = []
    for (let i = 1; i <= 39; i++) {
        if (![10, 15, 20, 25, 30, 35].includes(i)) {
            zoneArray.push({
                pitches: 0,
                api_gameday3_pitchzone_cd: i,
                zScore: 0,
                total_pitches: 0,
            })
        }
    }
    return zoneArray
}

const runValArray = data.map((d) => d.rv_tot)
const [runValMax, runValMin] = [
    Math.ceil(Math.max(...runValArray)) + 0,
    Math.floor(Math.min(...runValArray)) + 0,
]
const highlightRange = [runValMin, 0, runValMax].sort(
    (a, b) => Number(a) - Number(b)
)

const ELEMS_IN_DROPDOWN = 7
const ZONE_FILTER_MIN_RUNS = 0
const ZONE_FILTER_MAX_RUNS = 6.0
const ZONE_FILTER_DEFAULT_RUNS = 2.0
const ZONE_FILTER_RUN_STEP = 0.1

const NUM_VIZ_TABLE_ROWS = 8
const VIZ_TABLE_HIGHLIGHT_EXTREME = 0.14

const typesMap = {
    catcher: 'fielder_2',
    batter: 'player_at_bat',
    pitcher: 'pitcher',
    pitchtype: 'api_pitch_type_group03',
}
const textTypesMap = {
    catcher: 'f2_name_display_first_last',
    batter: 'b_name_display_first_last',
    pitcher: 'p_name_display_first_last',
}
const zoneHeaderMap = {
    'Shadow - Top': 'shadowtop',
    'Shadow - Bottom': 'shadowbottom',
    'Shadow - Left': 'shadowleft',
    'Shadow - Right': 'shadowright',
    Heart: 'heart',
    'Chase / Waste': 'chasewaste',
}

function loadTable(data, existingSort = null, existingSortDir = null) {
    if (showLeagueAverage) {
        data = [
            ...data,
            ...leagueData.map((d) => ({
                ...d,
                pinned: true,
            })),
        ]
    }
    const width = document.getElementById(tableDivId).offsetWidth
    let repeatHeader = false
    if (width <= 768) {
        repeatHeader = 15
    }

    const defaultSort = existingSort || 'rv_tot'
    const defaultSortDirection = existingSortDir || 'desc'

    const activeHeaders = isBreakdown ? headers : headersDefault
    new Table({
        id: tableDivId,
        repeatHeader,
        headers: concatGroupedHeaders(activeHeaders, groupHeaders),
        secondaryHeaders: isBreakdown
            ? secondaryHeaders
            : secondaryHeadersDefault,
        highlightFalsy: true,
        data,
        uniqueId: 'id',
        hasPinned: true,
        defaultSort,
        defaultSortDirection,
        sortClass: 'column-sort',
        showRank: true,
        sortCallback(column, _, { state }) {
            const url = new URL(window.location)
            url.searchParams.set('sortColumn', column)
            url.searchParams.set('sortDirection', state)
            window.history.replaceState('', '', url.toString())
            addHeaderZoneImages()
        },
        subDataId: 'id',
    })

    initStaticHeaders(tableDivId, data)
}

function buildZoneArray(zone) {
    const newZoneArray = getNewZoneArray()
    newZoneArray.forEach((elem) => {
        if (shadowZones.includes(elem.api_gameday3_pitchzone_cd)) {
            elem.zScore = elem.api_gameday3_pitchzone_cd === zone ? 3 : 0
        }
    })
    return newZoneArray
}

function buildDefaultZoneArray(zone) {
    const newZoneArray = getNewZoneArray()
    newZoneArray.forEach((elem) => {
        if (zone === 'shadowtop') {
            if (shadowTop.includes(elem.api_gameday3_pitchzone_cd)) {
                elem.zScore = 3
            }
        } else if (zone === 'shadowbottom') {
            if (shadowBottom.includes(elem.api_gameday3_pitchzone_cd)) {
                elem.zScore = 3
            }
        } else if (zone === 'shadowleft') {
            if (elem.api_gameday3_pitchzone_cd === 14) {
                elem.zScore = 3
            }
        } else if (zone === 'shadowright') {
            if (elem.api_gameday3_pitchzone_cd === 16) {
                elem.zScore = 3
            }
        } else if (zone === 'heart') {
            if (elem.api_gameday3_pitchzone_cd < 10) {
                elem.zScore = 3
            }
        } else if (zone === 'chasewaste') {
            if (elem.api_gameday3_pitchzone_cd > 20) {
                elem.zScore = 3
            }
        }
    })
    return newZoneArray
}

function buildPlayerZoneArray(playerData) {
    const newZoneArray = getNewZoneArray()
    newZoneArray.forEach((elem) => {
        if (shadowZones.includes(elem.api_gameday3_pitchzone_cd)) {
            elem.zScore = playerData[`rv_${elem.api_gameday3_pitchzone_cd}`]
        }
    })
    return newZoneArray
}

function createZoneChart(zone, size) {
    const opts = {
        id: `zone_${zone}`,
        svgId: `zone_${zone}_svg`,
        show_footer: 'false',
        type: 'zScore',
        width: size,
        height: size,
        backgroundColor: '#ddd',
        segmentStrokeWidth: 0,
        segmentStrokeColor: '#888',
        regions: {
            heart: true,
            shadow: true,
            chase: !isBreakdown,
            waste: !isBreakdown,
        },
        valueTags: false,
        tooltips: false,
        plate: true,
        footerText: '',
        zone_data: isBreakdown
            ? buildZoneArray(zone)
            : buildDefaultZoneArray(zone),
        colorScaleType: 'custom-orange',
    }

    attackZone(opts)
}

function addHeaderZoneImages() {
    const zoneHeaders = document.querySelectorAll('.th-title-header')
    zoneHeaders.forEach((zone) => {
        if (zone.innerHTML !== 'Totals') {
            const newId = isBreakdown
                ? zone.innerHTML.split(' ')[1]
                : zoneHeaderMap[zone.innerHTML]
            const childNode = zone.appendChild(document.createElement('div'))
            childNode.setAttribute('id', `zone_${newId}`)
        }
    })

    if (isBreakdown) {
        shadowZones.forEach((i) => {
            createZoneChart(i, 50)
        })
    } else {
        groupZones.forEach((i) => {
            createZoneChart(i, 80)
        })
    }
}

if (data && data.length) {
    loadTable(data)
    addHeaderZoneImages()
    if (serverParams.type === 'catcher') {
        loadVizDropdowns(vizData)
        loadVizTable(vizData)
        addSelectListeners()
    }
}

function addSelectListeners() {
    leftSelect.on('change', () => {
        loadVizTable(data)
        disableCatcherOptions()
    })

    rightSelect.on('change', () => {
        loadVizTable(data)
        disableCatcherOptions()
    })
}

function loadVizDropdowns(data) {
    const mappedData = data
        .map((d) => ({ name: d.name, id: d.id }))
        .sort((a, b) => (a.name.toLowerCase() <= b.name.toLowerCase() ? -1 : 1))

    leftSelect
        .selectAll('option')
        .data(mappedData)
        .join((enter) => {
            enter
                .append('option')
                .text((d) => d.name)
                .attr('value', (d) => d.id)
                .attr('id', (d) => `left-select-option-${d.id}`)
                .attr('class', 'left-select-options')
        })

    rightSelect
        .selectAll('option')
        .data(mappedData)
        .join((enter) => {
            enter
                .append('option')
                .text((d) => d.name)
                .attr('value', (d) => d.id)
                .attr('id', (d) => `right-select-option-${d.id}`)
                .attr('class', 'right-select-options')
        })

    // Select random catchers
    selectRandomCatchers(false)
}

function selectRandomCatchers(isButtonClick = true) {
    if (isButtonClick) {
        // If we're getting here from button click, select any two catchers
        const uniqueIDs = [...new Set(data.map((d) => d.id))]
        const numIDs = uniqueIDs.length

        const firstRandom = Math.floor(Math.random() * numIDs)
        let secondRandom = Math.floor(Math.random() * numIDs)

        if (numIDs > 1) {
            while (firstRandom === secondRandom) {
                secondRandom = Math.floor(Math.random() * numIDs)
            }
        }

        leftSelect.property('value', uniqueIDs[firstRandom])
        rightSelect.property('value', uniqueIDs[secondRandom])
    } else {
        // If we're getting here from page load, select from extrema
        const sortedData = vizData.sort((a, b) => a.pct_tot - b.pct_tot)

        let minDataIDs
        let maxDataIDs
        let numIDs = 5

        if (sortedData.length <= 5) {
            minDataIDs = [...sortedData].map((d) => d.id)
            maxDataIDs = [...minDataIDs]
            numIDs = sortedData.length
        } else {
            minDataIDs = sortedData.slice(0, 5).map((d) => d.id)
            maxDataIDs = sortedData.slice(-5).map((d) => d.id)
        }

        const firstRandom = Math.floor(Math.random() * numIDs)
        let secondRandom = Math.floor(Math.random() * numIDs)

        if (numIDs > 1) {
            while (minDataIDs[firstRandom] === maxDataIDs[secondRandom]) {
                secondRandom = Math.floor(Math.random() * numIDs)
            }
        }

        leftSelect.property('value', minDataIDs[firstRandom])
        rightSelect.property('value', maxDataIDs[secondRandom])
    }

    disableCatcherOptions()
}

function randomizeCatchers() {
    selectRandomCatchers()
    loadVizTable(data)
}

function disableCatcherOptions() {
    d3.selectAll('.left-select-options').property('disabled', false)
    d3.selectAll('.right-select-options').property('disabled', false)

    const leftSelected = leftSelect.node().value
    const rightSelected = rightSelect.node().value

    d3.select(`#left-select-option-${rightSelected}`).property('disabled', true)
    d3.select(`#right-select-option-${leftSelected}`).property('disabled', true)
}

function getVizTableColors(datum) {
    const vizTableHighlight = [
        -VIZ_TABLE_HIGHLIGHT_EXTREME,
        0,
        VIZ_TABLE_HIGHLIGHT_EXTREME,
    ]
    const scale = d3
        .scaleLinear()
        .clamp(true)
        .range(['#3661AD', '#ffffff', '#D82129'])
        .domain(vizTableHighlight)

    const bkgdColor = scale(datum)
    const textColor = setTextColorWithBackground(bkgdColor)

    return [bkgdColor, textColor]
}

function addVizTableRowListeners(leftSelected, rightSelected) {
    $('#viz-csr-table').off()
    $('#viz-csr-table').on(
        {
            mouseenter() {
                const bucketNum = Number(this.id.split('_')[1]) - 3.5
                graphViz.highlightVals(bucketNum, leftSelected, rightSelected)
            },
            mouseleave() {
                graphViz.clearHighlights()
            },
        },
        '.default-table-row'
    )
}

function loadVizTable(data) {
    const leftSelected = leftSelect.node().value
    const rightSelected = rightSelect.node().value

    const leftName = d3.select('#viz_left_select option:checked').text()
    const rightName = d3.select('#viz_right_select option:checked').text()

    const vizTableData = processVizTableData(
        Number(leftSelected),
        Number(rightSelected),
        data
    )

    new Table({
        id: 'viz-csr-table',
        data: vizTableData,
        sortClass: 'column-sort',
        headers: vizTableHeaders,
        secondaryHeaders: getSecondaryVizTableHeaders(
            leftSelected,
            rightSelected,
            leftName,
            rightName
        ),
        defaultSort: 'bucket',
        defaultSortDirection: 'asc',
    })

    // Color individual cells in viz table
    for (let i = 0; i < NUM_VIZ_TABLE_ROWS; i++) {
        const currRow = document.getElementById(`viz-csr-table-tr_${i}`)
        const leftCol = currRow.childNodes[1]
        const rightCol = currRow.childNodes[3]

        const [leftBkgdColor, leftTextColor] = getVizTableColors(
            vizTableData[i].leftDiff
        )
        const [rightBkgdColor, rightTextColor] = getVizTableColors(
            vizTableData[i].rightDiff
        )

        leftCol.style.backgroundColor = leftBkgdColor
        leftCol.style.color = leftTextColor

        rightCol.style.backgroundColor = rightBkgdColor
        rightCol.style.color = rightTextColor
    }

    setTimeout(() => {
        graphViz.highlightChosenPlayers(leftSelected, rightSelected)
    }, 200)

    addVizTableRowListeners(leftSelected, rightSelected)
}

function processVizTableData(leftID, rightID, data) {
    const newData = []
    const leftData = data.find((d) => Number(d.id) === leftID)
    const rightData = data.find((d) => Number(d.id) === rightID)

    for (let i = ZONE_INCHES_LIMIT * -1 - 1; i <= ZONE_INCHES_LIMIT; i++) {
        const key = i < 0 ? `minus${Math.abs(i)}` : `${i}`
        const dataObj = {
            bucket: i,
            leftVal: leftData[`pct_bin_${key}`],
            leagueVal: leagueData[0][`pct_bin_${key}`],
            rightVal: rightData[`pct_bin_${key}`],
            leftDiff:
                leftData[`pct_bin_${key}`] - leagueData[0][`pct_bin_${key}`],
            rightDiff:
                rightData[`pct_bin_${key}`] - leagueData[0][`pct_bin_${key}`],
        }

        newData.push(dataObj)
    }

    newData.sort((a, b) => Number(a.bucket) - Number(b.bucket))
    return newData
}

document.getElementById('btn-update').addEventListener('click', () => {
    window.location = populateUrl({
        minPitches: document.getElementById('ddlMinPitches')?.value,
        minResults: document.getElementById('ddlMinResults')?.value,
        ballStrike: document.getElementById('ddlBallStrike')?.value,
    })
})

const $shadowBreakdownToggle = document.getElementById('btn-shadow')

$shadowBreakdownToggle.addEventListener('click', () => {
    isBreakdown = !isBreakdown

    if (isBreakdown) {
        $shadowBreakdownToggle.innerHTML = 'Show Default Groupings'
    } else {
        $shadowBreakdownToggle.innerHTML = 'Show Shadow Zone Breakdown'
    }

    const currentParams = new URLSearchParams(window.location.search)
    loadTable(
        data,
        currentParams.get('sortColumn'),
        currentParams.get('sortDirection')
    )
    addHeaderZoneImages()
})

if (serverParams.type === 'catcher' && data.length) {
    document
        .getElementById('btn-toggle-x-axis')
        .addEventListener('click', graphViz.toggleXAxis)

    document
        .getElementById('btn-randomize')
        .addEventListener('click', randomizeCatchers)
}

const $leagueAverageToggle = document.getElementById(
    'btn-toggle-league-average'
)

$leagueAverageToggle?.addEventListener('click', () => {
    showLeagueAverage = !showLeagueAverage
    const currentParams = new URLSearchParams(window.location.search)
    loadTable(
        data,
        currentParams.get('sortColumn'),
        currentParams.get('sortDirection')
    )
    addHeaderZoneImages()
})

async function getFramingPitches(params, playerId) {
    let url = `/leaderboard/services/catcher-framing/${playerId}`
    if (params.toString().length > 0) {
        url += `?${params.toString()}`
    }
    const { data } = await fetch(url).then((res) => res.json())
    return data
}

function groupPitches(pitches) {
    const pitchGroupings = {}

    const types = ['catcher', 'batter', 'pitcher', 'pitchtype']
    const currType = serverParams.type

    types.forEach((groupingType) => {
        if (groupingType === currType) {
            return
        }

        const handledGroups = []
        const groupedPitches = pitches.reduce((acc, pitch) => {
            if (!handledGroups.includes(pitch[typesMap[groupingType]])) {
                handledGroups.push(pitch[typesMap[groupingType]])

                const newObj = {}

                newObj[typesMap[currType]] = pitch[typesMap[currType]]
                newObj[textTypesMap[currType]] = pitch[textTypesMap[currType]]
                newObj[typesMap[groupingType]] = pitch[typesMap[groupingType]]

                if (groupingType !== 'pitchtype') {
                    newObj[textTypesMap[groupingType]] =
                        pitch[textTypesMap[groupingType]]
                }

                newObj.catcher_framing_runs = pitch.catcher_framing_runs
                newObj.tot_pitches = 1

                acc.push(newObj)
            } else {
                const groupedObjIndex = acc.findIndex(
                    (d) =>
                        pitch[typesMap[currType]] === d[typesMap[currType]] &&
                        pitch[typesMap[groupingType]] ===
                            d[typesMap[groupingType]]
                )
                acc[groupedObjIndex].catcher_framing_runs +=
                    pitch.catcher_framing_runs

                acc[groupedObjIndex].tot_pitches += 1
            }
            return acc
        }, [])

        pitchGroupings[groupingType] = groupedPitches
    })

    return pitchGroupings
}

function modifyTextLabel(e) {
    const [, gainedLost, idNum] = e.target.id.split('_')
    const isGained = gainedLost === 'gained'
    const sliderText = document.getElementById(
        `slider_${gainedLost}_text_${idNum}`
    )
    sliderText.innerHTML = `<strong>${
        isGained
            ? 'Min. Inches Outside (Strikes)'
            : 'Min. Inches Inside (Balls)'
    }:</strong> ${Number(e.target.value).toFixed(1)}`
}

function populateStrikeZoneViz($wrapper, pitchData, id) {
    const $svgWrapper = document.createElement('div')
    $wrapper.appendChild($svgWrapper)
    $svgWrapper.setAttribute('id', `all_viz_${id}`)
    $svgWrapper.classList.add('strike-zone-viz')

    const totalData =
        serverParams.type === 'league'
            ? data[0]
            : data.filter((d) => Number(d.id) === Number(id))[0]

    const opts = {
        id: `all_viz_${id}`,
        svgId: `all_viz_${id}_svg`,
        show_footer: 'false',
        type: 'zScore',
        width: 400,
        height: 400,
        backgroundColor: '#ddd',
        segmentStrokeWidth: 1,
        segmentStrokeColor: '#ddd',
        regions: {
            heart: true,
            shadow: true,
            chase: true,
            waste: true,
        },
        valueTags: false,
        tooltips: false,
        plate: true,
        footerText: '',
        zoneThickness: 3,
        zoneDash: `6,10`,
        zoneId: id,
        customHighlight: serverParams.type === 'league' ? null : highlightRange,
        zone_data: buildPlayerZoneArray(totalData),
    }

    attackZone(opts)
    viz.plotPitches(opts.svgId, id, pitchData)
}

function fillDropdownLeft($leftWrapper, id, pitchData) {
    const sliceNum = Math.min(ELEMS_IN_DROPDOWN, pitchData.length)

    const topData = pitchData.slice(0, sliceNum)
    const botData = pitchData.slice(sliceNum * -1).reverse()

    // const posPitches = pitchData
    //     .filter((d) => d.catcher_framing_runs > 0)
    //     .length.toLocaleString()
    // const negPitches = pitchData
    //     .filter((d) => d.catcher_framing_runs < 0)
    //     .length.toLocaleString()

    const $h3Top = document.createElement('h4')
    $h3Top.innerText = `Top Strikes Gained Outside Zone`
    const $h3Bot = document.createElement('h4')
    $h3Bot.innerText = `Top Strikes Lost Inside Zone`

    $h3Top.classList.add('drawer-inside-header')
    $h3Bot.classList.add('drawer-inside-header')

    const $allTableDiv = document.createElement('div')
    $allTableDiv.id = `all_${id}`
    const $allTableDivBot = document.createElement('div')
    $allTableDivBot.id = `allbot_${id}`

    $allTableDiv.classList.add('drawer-inside-table')
    $allTableDivBot.classList.add('drawer-inside-table')

    $leftWrapper.appendChild($h3Top)
    $leftWrapper.appendChild($allTableDiv)
    $leftWrapper.appendChild($h3Bot)
    $leftWrapper.appendChild($allTableDivBot)

    new Table({
        id: $allTableDiv.id,
        data: topData,
        sortClass: 'column-sort',
        rowClass: 'inner-table',
        headers: allPitchHeaders,
        defaultSort: 'edge_dist_calc',
        defaultSortDirection: 'desc',
        uniqueId: 'play_id',
    })

    new Table({
        id: $allTableDivBot.id,
        data: botData,
        sortClass: 'column-sort',
        rowClass: 'inner-table',
        headers: allPitchHeaders,
        defaultSort: 'edge_dist_calc',
        defaultSortDirection: 'asc',
        uniqueId: 'play_id',
    })
}

function createGroupedTable(leftDiv, idNum, data, buttonType) {
    const headerTextMap = {
        batter: 'Batter',
        pitcher: 'Pitcher',
        catcher: 'Catcher',
        pitchtype: 'Pitch Type',
    }

    const $h3Top = document.createElement('h4')
    $h3Top.innerText = `Framing Runs Broken Down by ${headerTextMap[buttonType]}`
    $h3Top.classList.add('drawer-inside-header')

    const $groupedTableDiv = document.createElement('div')
    $groupedTableDiv.id = `grouped_${buttonType}_${idNum}`
    $groupedTableDiv.classList.add('drawer-inside-table')

    leftDiv.appendChild($h3Top)
    leftDiv.appendChild($groupedTableDiv)

    new Table({
        id: $groupedTableDiv.id,
        data,
        sortClass: 'column-sort',
        rowClass: 'inner-table',
        showRank: true,
        headers: getGroupedTableHeaders(buttonType),
        defaultSort: 'catcher_framing_runs',
        defaultSortDirection: 'desc',
        uniqueId: typesMap[buttonType],
    })
}

function respondToDropdownInput(id, pitchData) {
    viz.removePitches(id)
    viz.plotPitches(`all_viz_${id}_svg`, id, pitchData, {
        maxThreshold: document.getElementById(`slider_gained_${id}`).value,
        minThreshold: document.getElementById(`slider_lost_${id}`).value,
        filterNonK: document.getElementById(`strikeout_checkbox_${id}`).checked,
        filterNonBB: document.getElementById(`walk_checkbox_${id}`).checked,
    })
}

function createSliders(pitchData, id) {
    const $gainedSliderDiv = document.createElement('div')
    $gainedSliderDiv.classList.add('framing-runs-slider-div')

    const $gainedSliderText = document.createElement('div')
    $gainedSliderText.setAttribute('id', `slider_gained_text_${id}`)
    $gainedSliderText.innerHTML = `<strong>Min. Inches Outside (Strikes):</strong> ${ZONE_FILTER_DEFAULT_RUNS.toFixed(
        1
    )}`

    const $gainedSlider = document.createElement('input')
    $gainedSlider.classList.add('framing-runs-gained-slider')
    $gainedSlider.setAttribute('id', `slider_gained_${id}`)
    $gainedSlider.setAttribute('type', 'range')
    $gainedSlider.setAttribute('min', ZONE_FILTER_MIN_RUNS)
    $gainedSlider.setAttribute('max', ZONE_FILTER_MAX_RUNS)
    $gainedSlider.setAttribute('step', ZONE_FILTER_RUN_STEP)
    $gainedSlider.setAttribute('value', ZONE_FILTER_DEFAULT_RUNS)

    $gainedSliderDiv.appendChild($gainedSliderText)
    $gainedSliderDiv.appendChild($gainedSlider)

    const $lostSliderDiv = document.createElement('div')
    $lostSliderDiv.classList.add('framing-runs-slider-div')

    const $lostSliderText = document.createElement('div')
    $lostSliderText.setAttribute('id', `slider_lost_text_${id}`)
    $lostSliderText.innerHTML = `<strong>Min. Inches Inside (Balls):</strong> ${ZONE_FILTER_DEFAULT_RUNS.toFixed(
        1
    )}`

    const $lostSlider = document.createElement('input')
    $lostSlider.classList.add('framing-runs-lost-slider')
    $lostSlider.setAttribute('id', `slider_lost_${id}`)
    $lostSlider.setAttribute('type', 'range')
    $lostSlider.setAttribute('min', ZONE_FILTER_MIN_RUNS)
    $lostSlider.setAttribute('max', ZONE_FILTER_MAX_RUNS)
    $lostSlider.setAttribute('step', ZONE_FILTER_RUN_STEP)
    $lostSlider.setAttribute('value', ZONE_FILTER_DEFAULT_RUNS)

    $lostSliderDiv.appendChild($lostSliderText)
    $lostSliderDiv.appendChild($lostSlider)

    $gainedSlider.addEventListener('input', (e) => {
        modifyTextLabel(e)
        respondToDropdownInput(id, pitchData)
    })

    $lostSlider.addEventListener('input', (e) => {
        modifyTextLabel(e)
        respondToDropdownInput(id, pitchData)
    })

    return [$gainedSliderDiv, $lostSliderDiv]
}

function createCheckboxes(pitchData, id) {
    const $checkboxes = document.createElement('div')
    $checkboxes.classList.add('checkboxes-div')

    const $strikeoutDiv = document.createElement('div')
    $strikeoutDiv.classList.add('strikeout-checkbox-div')

    const $strikeoutCheck = document.createElement('input')
    $strikeoutCheck.classList.add('drawer-checkboxes')
    $strikeoutCheck.setAttribute('id', `strikeout_checkbox_${id}`)
    $strikeoutCheck.setAttribute('type', 'checkbox')
    $strikeoutCheck.setAttribute('name', 'filter-strikeouts')

    const $strikeoutLabel = document.createElement('label')
    $strikeoutLabel.innerHTML = 'Show only PA-ending strikes'
    $strikeoutLabel.setAttribute('for', `strikeout_checkbox_${id}`)

    const $walkDiv = document.createElement('div')
    $walkDiv.classList.add('walk-checkbox-div')

    const $walkCheck = document.createElement('input')
    $walkCheck.classList.add('drawer-checkboxes')
    $walkCheck.setAttribute('id', `walk_checkbox_${id}`)
    $walkCheck.setAttribute('type', 'checkbox')
    $walkCheck.setAttribute('name', 'filter-walks')

    const $walkLabel = document.createElement('label')
    $walkLabel.innerHTML = 'Show only PA-ending balls'
    $walkLabel.setAttribute('for', `walk_checkbox_${id}`)

    $strikeoutCheck.addEventListener('click', () => {
        respondToDropdownInput(id, pitchData)
    })

    $walkCheck.addEventListener('click', () => {
        respondToDropdownInput(id, pitchData)
    })

    $strikeoutDiv.appendChild($strikeoutCheck)
    $strikeoutDiv.appendChild($strikeoutLabel)
    $walkDiv.appendChild($walkCheck)
    $walkDiv.appendChild($walkLabel)
    $checkboxes.appendChild($strikeoutDiv)
    $checkboxes.appendChild($walkDiv)

    return $checkboxes
}

function fillDropdownRight($rightWrapper, id, pitchData) {
    const $strikeZoneViz = document.createElement('div')
    $strikeZoneViz.classList.add('drawer-inside-viz')
    $strikeZoneViz.setAttribute('id', `drawer_${id}`)

    const [$gainedSliderDiv, $lostSliderDiv] = createSliders(pitchData, id)
    const $checkboxes = createCheckboxes(pitchData, id)

    $rightWrapper.appendChild($strikeZoneViz)
    $rightWrapper.appendChild($gainedSliderDiv)
    $rightWrapper.appendChild($lostSliderDiv)
    $rightWrapper.appendChild($checkboxes)

    populateStrikeZoneViz($strikeZoneViz, pitchData, id)
}

function addRowListener(pitchData) {
    $('.drawer-inside-table').on(
        {
            mouseenter() {
                if (!groupedView) {
                    const [, playerIdRaw, playId] = this.id.split('_')
                    const playerId = playerIdRaw.split('-tr')[0]
                    const datum = pitchData.filter(
                        (d) => d.play_id === playId
                    )[0]
                    viz.handleTableMouseOver(playerId, playId, datum)
                } else {
                    const [, type, playerIdRaw, groupedId] = this.id.split('_')
                    const playerId = playerIdRaw.split('-tr')[0]
                    viz.handleGroupedTableMouseOver(type, playerId, groupedId)
                }
            },
            mouseleave() {
                if (!groupedView) {
                    const [, playerIdRaw, playId] = this.id.split('_')
                    const playerId = playerIdRaw.split('-tr')[0]
                    viz.handleTableMouseOff(playerId, playId)
                } else {
                    const [, , playerIdRaw] = this.id.split('_')
                    const playerId = playerIdRaw.split('-tr')[0]
                    viz.handleGroupedTableMouseOff(playerId)
                }
            },
        },
        '.default-table-row'
    )
}

function createAllPitchesTables($wrapper, id, pitchData) {
    const $tabWrapper = document.createElement('div')
    $tabWrapper.classList.add('drawer-inside-wrapper')
    $tabWrapper.setAttribute('id', `inner_tab_${id}`)

    const $leftWrapper = document.createElement('div')
    $leftWrapper.classList.add('drawer-left-wrapper')
    $leftWrapper.setAttribute('id', `left_tab_${id}`)
    const $rightWrapper = document.createElement('div')
    $rightWrapper.classList.add('drawer-right-wrapper')

    $wrapper.appendChild($tabWrapper)
    $tabWrapper.appendChild($leftWrapper)
    $tabWrapper.appendChild($rightWrapper)

    fillDropdownLeft($leftWrapper, id, pitchData)
    fillDropdownRight($rightWrapper, id, pitchData)

    addRowListener(pitchData)
}

function addDrawerTabs($wrapperDiv, idNum) {
    let drawerTabs = `
    <div class="drawer-tabs">
        <button data-tab="all" class="tab-all drawer-nav active" id="all_button_${idNum}" >
            Best/Worst Frames
        </button>
        `

    if (serverParams.type !== 'catcher') {
        drawerTabs += `<button data-tab="catcher_id" class="tab-catcher drawer-nav" id="catcher_button_${idNum}" >
            By Catcher
        </button>
        `
    }

    if (serverParams.type !== 'batter') {
        drawerTabs += `<button data-tab="batter_id" class="tab-batter drawer-nav" id="batter_button_${idNum}" >
            By Batter
        </button>
        `
    }

    if (serverParams.type !== 'pitcher') {
        drawerTabs += `<button data-tab="pitcher_id" class="tab-pitcher drawer-nav" id="pitcher_button_${idNum}" >
            By Pitcher
        </button>
        `
    }

    drawerTabs += `<button data-tab="throw_type" class="tab-pitch-type drawer-nav" id="pitchtype_button_${idNum}" >
            By Pitch Type
        </button>
    </div>
    `

    $wrapperDiv.innerHTML = drawerTabs
}

async function handleBreakdownTable(leftDiv, buttonType, idNum) {
    let data
    if (buttonType === 'all') {
        groupedView = false
        data = framingPitchesMap[idNum]
        fillDropdownLeft(leftDiv, idNum, data)
    } else {
        groupedView = true
        data = groupedPitchesMap[idNum][buttonType]
        createGroupedTable(leftDiv, idNum, data, buttonType)
    }

    addRowListener(data)
}

function handleTabSwitch($button) {
    const [buttonType, , idNum] = $button.id.split('_')
    const leftDiv = $(`#left_tab_${idNum}`)
    const leftDivDoc = document.getElementById(`left_tab_${idNum}`)

    if (!$button.classList.contains('active')) {
        leftDiv.empty()
        $button
            .closest('.drawer-tabs')
            .querySelectorAll('.drawer-nav')
            .forEach(($el) => {
                $el.classList.remove('active')
            })
        $button.classList.add('active')
        handleBreakdownTable(leftDivDoc, buttonType, idNum)
    }
}

if (data.length) {
    document.getElementById(tableDivId).addEventListener('click', async (e) => {
        if (serverParams.secondaryGroupBy.length > 0) {
            return
        }

        const $a = e.target.closest('a')
        const $el = e.target.closest('tr.default-table-row')
        const $button = e.target.closest('.drawer-nav')

        if ($button) {
            handleTabSwitch($button)
            return
        }

        if ($a || !$el || $el.classList.contains('inner-table')) {
            // eslint-disable-next-line
        return
        }

        const $sub = $el.nextSibling
        const $td = $sub.querySelector('td')
        const $wrapperDiv = document.createElement('div')

        const id = `data_${$el.dataset.id}`
        const idNum = $el.dataset.id
        const $innerDiv = document.getElementById(id)

        if ($innerDiv) {
            if ($sub.dataset.open === 'true') {
                slideUp($innerDiv, 400)
                $sub.dataset.open = 'false'
                return
            }
            slideDown($innerDiv, 400)
            $sub.dataset.open = 'true'
            return
        }

        $wrapperDiv.classList.add('framing-drawer')
        $wrapperDiv.id = id
        $wrapperDiv.textContent = `Loading...${
            serverParams.type === 'league' ? ' (this may take a while)' : ''
        }`

        $sub.style.display = 'table-row'

        $td.appendChild($wrapperDiv)

        const params = new URLSearchParams(window.location.search)

        let framingPitches
        let groupedPitches

        if (Object.keys(framingPitchesMap).includes(idNum)) {
            framingPitches = framingPitchesMap[idNum]
            groupedPitches = groupedPitchesMap[idNum]
        } else {
            framingPitches = await getFramingPitches(params, $el.dataset.id)
            groupedPitches = groupPitches(framingPitches)
            framingPitchesMap[idNum] = framingPitches
            groupedPitchesMap[idNum] = groupedPitches
        }

        $wrapperDiv.style.display = 'none'
        $wrapperDiv.textContent = ''

        addDrawerTabs($wrapperDiv, idNum)

        createAllPitchesTables($wrapperDiv, idNum, framingPitches)
        slideDown($wrapperDiv, 400)
        $sub.dataset.open = 'true'
    })
}
